import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';
import { MenuService } from 'src/app/services/menu-service/menu.service';

type MenuKey = keyof ModelLocatorService['menu'];

interface FooterMenuItem {
    route: string;
    icon: string;
    label: string;
    condition?: MenuKey;
    hidden: boolean;
    disabled: boolean;
}

@Component({
    selector: 'app-mm-menu-footer',
    templateUrl: './mm-menu-footer.component.html',
    styleUrls: ['./mm-menu-footer.component.scss'],
})
export class MmMenuFooterComponent implements OnInit {

    public menuFooter: FooterMenuItem[] = [
        {
            route: '/home',
            icon: '../../../assets/icon/menu/interacao-icon.png',
            label: 'INTERAÇÃO',
            condition: 'interacao',
            hidden: false,
            disabled: false
        },
        {
            route: '/activation-pre',
            icon: '../../../assets/icon/menu/ativacao-icon.png',
            label: 'REGISTRAR',
            condition: 'ativacoes',
            hidden: false,
            disabled: false
        },
        {
            route: '/store',
            icon: '../../../assets/icon/menu/premiacao-icon.png',
            label: 'LOJA',
            condition: 'premiacao',
            hidden: false,
            disabled: false
        },
        {
            route: '/challenges/list-of-challenges',
            icon: '../../../assets/icon/menu/superacao-icon.png',
            label: 'SUPERAÇÃO',
            condition: 'desafios',
            hidden: false,
            disabled: false
        },
        {
            route: '/help',
            icon: '../../../assets/icon/menu/info-icon.png',
            label: 'SUPORTE',
            condition: 'suporte',
            hidden: false,
            disabled: false
        }
    ];

    constructor(
        public modelLocator: ModelLocatorService,
        public platform: Platform,
        private menuService: MenuService,
        private router: Router
    ) {
    }

    async ngOnInit() {
        this.menuFooter = await this.menuService.disableOrHiddenMenu(this.menuFooter);
    }

    touchGoToRoute(item: FooterMenuItem): void {
        if (item.disabled) return;
        this.router.navigate([item.route]);
    }

    /**
     * Returns true if the menu item is enabled and the current profile is not hidden.
     * @param item - footer menu item with optional condition key
     */
    getCondition(item: FooterMenuItem): boolean {
        return (!item.condition || !!this.modelLocator.menu[item.condition]) && !item.hidden;
    }

}
